import RefreshIcon from '@mui/icons-material/Refresh';
import Sync from '@mui/icons-material/Sync';
import { Button, CircularProgress } from '@mui/material';
import { FC } from 'react';

export type ButtonType = 'refresh' | 'retry';

type Props = {
  onClick: () => void;
  isLoading: boolean;
  type?: ButtonType;
};

const getIcon = (isLoading: boolean, type: ButtonType) => {
  if (isLoading) {
    return <CircularProgress aria-label="Loading..." color="inherit" size={20} />;
  }
  if (type === 'refresh') {
    return <RefreshIcon />;
  }
  return <Sync />;
};

const RefreshButton: FC<Props> = ({ onClick, isLoading, type = 'refresh' }) => (
  <Button
    onClick={onClick}
    fullWidth
    variant="soft"
    size="large"
    startIcon={getIcon(isLoading, type)}
    sx={{ textTransform: 'capitalize' }}
    disabled={isLoading}
  >
    {type}
  </Button>
);

export default RefreshButton;
